import React from 'react';
import Select from 'react-select';
import { ValueType } from 'react-select/src/types';

export interface Option {
  label: string;
  value: string;
  name: string;
}

interface Params {
  form: string;
  name: string;
  label: string;
  options: Option[];
  isMulti?: boolean;
  selected?: string | string[];
  onChange: (option: ValueType<Option>) => void;
}

export class SelectInput extends React.Component<Params> {
  state = {
    selected: this.props.selected,
  };

  render() {
    const { label, name, options, isMulti, selected } = this.props;
    const value = options.filter((option) => {
      if (Array.isArray(selected)) {
        return selected.includes(option.value);
      }
      return option.value === selected;
    });

    return (
      <div className='field'>
        <label>{label}</label>
        <Select
          isMulti={isMulti}
          name={name}
          value={value}
          onChange={this.props.onChange}
          options={options}
        />
      </div>
    );
  }
}
